import { createFileRoute, Navigate } from '@tanstack/react-router'
import { useWorkspaceType } from '@/hooks/useWorkspaceType'
import { HomeDashboard } from '@/components/compliance/HomeDashboard'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/dashboard'
)({
  component: WorkspaceDashboardPage,
})

function WorkspaceDashboardPage() {
  const { workspaceId } = Route.useParams()
  const { type } = useWorkspaceType()
  return type === 'SCREENATA' ? (
    <Navigate to='/workspaces/$workspaceId/' params={{ workspaceId }} replace />
  ) : (
    <HomeDashboard workspaceId={workspaceId} />
  )
}
